import React from 'react';
import InvoicesDashboard from '../../features/invoices/components/InvoicesDashboard';

const InvoicesPage: React.FC = () => {
    return <InvoicesDashboard />;
};

export default InvoicesPage;
